export default __webpack_public_path__ + "static/media/NTORQ 125 RT FI_2.7c59edcc.webp";